module.exports = __webpack_public_path__ + "882f89cdb5e4517fb6fb8957d7f15820.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/foldermanager_header_asc_2x.png
// module id = 131
// module chunks = 0 1 2 3 4